import {
  Star, Rocket, Crown, Brain, Trophy,
  Lightbulb, Leaf, Fire, Target, Sparkle,
} from "@phosphor-icons/react";

/**
 * Icon config for study plans.
 * bg / text are Tailwind classes from Bloom's design system.
 */
export const PLAN_ICON_CONFIG = {
  star:     { Icon: Star,      bg: "bg-secondary/15",  text: "text-secondary-ink"  },
  rocket:   { Icon: Rocket,    bg: "bg-primary/15",    text: "text-primary-strong" },
  crown:    { Icon: Crown,     bg: "bg-warning/15",    text: "text-warning-ink"    },
  brain:    { Icon: Brain,     bg: "bg-teal/15",       text: "text-teal-ink"       },
  trophy:   { Icon: Trophy,    bg: "bg-secondary/15",  text: "text-secondary-ink"  },
  bulb:     { Icon: Lightbulb, bg: "bg-warning/15",    text: "text-warning-ink"    },
  leaf:     { Icon: Leaf,      bg: "bg-teal/15",       text: "text-teal-ink"       },
  flame:    { Icon: Fire,      bg: "bg-primary/15",    text: "text-primary-strong" },
  target:   { Icon: Target,    bg: "bg-secondary/15",  text: "text-secondary-ink"  },
  sparkles: { Icon: Sparkle,   bg: "bg-primary/15",    text: "text-primary-strong" },
};

export const ICON_KEYS = Object.keys(PLAN_ICON_CONFIG);

/** Resolve icon config safely — falls back to star. */
export function iconConfig(key) {
  return PLAN_ICON_CONFIG[key] ?? PLAN_ICON_CONFIG.star;
}
